import classNames from 'classnames';
import { ReactElement } from 'react';
import CloseIcon from '@material-ui/icons/Close';

// Styles
import styles from './faq.module.scss';

// Core + Store
import { ITaxonomyTerm } from 'core/models';

interface IFaqProps {
  handleClose: () => void;
  faqTitle: string;
  faqs: ITaxonomyTerm[];
  faqArea: string;
  isLinks?: boolean;
  isIgnoreFiltering?: boolean;
  isJa?: boolean;
}

const Faq = (props: IFaqProps): ReactElement => {
  const { handleClose, faqTitle, faqs = [], faqArea, isLinks, isIgnoreFiltering, isJa } = props;
  const renderedFaqs: ITaxonomyTerm[] = isIgnoreFiltering
    ? faqs
    : faqs.filter(
        ({ metadataText, metadataNumber }) =>
          metadataText === faqArea &&
          ((!isJa && metadataNumber === 1) || (isJa && metadataNumber === 2) || metadataNumber === 3),
      );

  return (
    <div className="faq-content">
      <button className="close" aria-label="close" onClick={handleClose}>
        <CloseIcon />
      </button>
      {faqTitle && <h5>{faqTitle}</h5>}
      {!!renderedFaqs?.length && (
        <ul className={classNames({ links: isLinks })}>
          {renderedFaqs.map(({ description, id, name }) => (
            <li key={id}>
              {!isLinks && <span className={styles.bold}>{name}</span>}
              <div dangerouslySetInnerHTML={{ __html: description || '' }} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Faq;
